module.exports = __webpack_public_path__ + "static/media/salesforce_colour.6450908e.svg";